/** 
 * Search Companies
 * - Search by name, ability to select multiple companies
 * - Dispaly reults in a list or view wells on map
 * */

/**
 * Step 2 In funnel
 * Select treatement wells
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import {
  Typography, Drawer, Box, Select, MenuItem, Stack,
  FormControl, TextField, InputLabel, Button, IconButton,
  Grid, Tabs, Tab, useMediaQuery,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import PersonIcon from '@mui/icons-material/Person';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';

import Map from '../../components/Map';
import Search from '../../components/Search';
import SearchCompanies from '../../components/Search/SearchCompanies';
import CompanyWellTable from '../../components/CompanyWellTable';

import useCartofactWells from '../../hooks/useCartofactWells';

const drawerWidth = 240;

const containerStyle = {
  width: '100vw',
  height: '100vh',
  position: 'relative'
};

const mapContainerStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  bottom: 0,
  width: '100%',
  height: '100%',
  zIndex: 1
};

const CompaniesPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

  const {
    filter,
    operator,
    companyIds,
    cartofactWells,
    selectedTreatmentWells,
    ...fzpState
  } = useSelector(state => state.fpzReducer);
  // order by distance from selected well if selectedTreamentWells.length > 0
  //const orderBy = selectedTreatmentWells?.length > 0 ? {
  //orderBy: 
  //} : null;
  useCartofactWells({ toggleCartofactWells: true, boundingBox: fzpState?.map?.boundingBox, filter, operator, companyIds });

  const [mapCenter, setMapCenter] = useState(null);
  const [mapZoom, setMapZoom] = useState(null);
  const [tabIndex, setTabIndex] = useState(0);

  const defaultFpzRadius = 500;
  const defaultFpzRadiusColor = '#66FFFF';

  const handleChangeFpzRadius = (index, fpzRadius, well) => {
    console.log('handleChangeFpzRadius', index, fpzRadius, well);
    dispatch({ type: 'UPDATE_FPZ_RADIUS', payload: { index, fpzRadius, well } });
    dispatch({ type: 'SET_OFFSET_WELLS', payload: { well, offsetWells: [] } }); // clear offsets on fpz radius change
  };

  const handleAddFpzRadius = (well) => {
    dispatch({ type: 'ADD_FPZ_RADIUS', payload: well });
    dispatch({ type: 'SET_OFFSET_WELLS', payload: { well, offsetWells: [] } }); // clear offsets on fpz radius change
  }

  const handleDeleteFpzRadius = (index, well) => {
    dispatch({ type: 'DELETE_FPZ_RADIUS', payload: { index, well } });
    dispatch({ type: 'SET_OFFSET_WELLS', payload: { well, offsetWells: [] } }); // clear offsets on fpz radius change
  }

  const handleClickWell = (well) => {
    console.log('handleClickWell', well);
    setMapCenter({ lat: well.lat, lng: well.lng });
    setMapZoom(15);
  }

  const handleDeleteWell = (well) => {
    dispatch({ type: 'DELETE_TREATMENT_WELL', payload: well });
  }

  /**
   * Tabs
   */
  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <Box>
      {/* Map */}
      <Box sx={mapContainerStyle}>
        <Box
          sx={{
            position: 'absolute',
            top: 100,
            right: 16,
            left: isMdUp ? 285 : 0,
            zIndex: 2, // Make sure it's above the map
            bgcolor: 'background.paper',
            borderRadius: 1,
            boxShadow: 2,
            p: 1,
          }}
        >
          <SearchCompanies />
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="inherit"
            variant="scrollable"
            scrollButtons="auto"
            className="no-print"
          >
            <Tab
              key={0}
              value={0}
              label="Map View*"
              title="View Wells in Map View"
            />
            <Tab
              key={1}
              value={1}
              label="Table View*"
              title="View Wells in Table View"
            />
          </Tabs>

          {
            tabIndex === 1 && (
              <Box
                sx={{
                  p: 1,
                  pb: 150,
                }}
              >
                <CompanyWellTable rows={cartofactWells} />
              </Box>
            )
          }

        </Box>
        {
          tabIndex === 0 && (
            <Map
              mapContainerStyle={{ width: '100%', height: '100%' }}
              center={{ lat: 49.5, lng: -100 }}
              zoom={5}
              cartofactWells={cartofactWells}
              //defaultFpzRadius={defaultFpzRadius}
              //selectedTreatmentWells={selectedTreatmentWells}
              //defaultFpzRadiusColor={defaultFpzRadiusColor}
              newCenter={mapCenter}
              newZoom={mapZoom}
            />
          )
        }

      </Box>


    </Box>
  );
};

export default CompaniesPage;
